module.exports = __webpack_public_path__ + "img/图片4.4de50e09.png";